module.exports = __webpack_public_path__ + "static/carrier-registration-3b2374c6afd3fb07d1c22b46e3c1a06d.png";